import styled from '@emotion/styled';
import { Button, Stack } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { motion } from 'framer-motion';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const PositionWrapper = styled(Stack)<{ isMobileLandscape: boolean }>`
  position: fixed;
  z-index: ${VIEWER_Z_INDEX.mobileLayer};

  ${({ isMobileLandscape }) =>
    isMobileLandscape
      ? `
        top: 16px;
        `
      : `
        bottom: 16px;
    `}

  right: 16px;
  width: auto;
  height: auto;
`;

export const ArrowButton = styled(Button)`
  z-index: ${VIEWER_Z_INDEX.mobileLayer};

  width: 43px;
  height: 43px;
  padding: 8px;

  border: 1px solid ${theme.colors.zinc_300};

  box-shadow: none;

  transition: opacity 0.15s ease-in-out;

  &.backgroundOpacity {
    opacity: 0.5;
  }

  &.disable {
    cursor: initial;
    opacity: 0;
  }
`;

export const MotionDiv = styled(motion.div)<{ isFlexRow: boolean }>`
  display: flex;
  flex-direction: ${({ isFlexRow }) => (isFlexRow ? 'row' : 'column')};
  gap: 8px;
`;
